import { ChangeDetectionStrategy, Component } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import ProjectLinks from 'src/app/common/project.links';
import { SocialInitiativeInfoComponentShared } from 'src/app/components/shared/social-initiative/social-initiative-info-component.shared';
import { Project } from 'src/app/swagger-api';

@Component({
  selector: 'app-project-info',
  templateUrl: './project-info.component.html',
  styleUrls: ['./project-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectInfoComponent extends SocialInitiativeInfoComponentShared<Project> {
  public readonly DATE_FORMAT_LONG: string = AppValues.DATE_FORMAT_LONG;

  public get communityLink(): string[] {
    return this.entity.community
      ? [
          this.entity.community.focus === 'HEALTH' ? ProjectLinks.LINK_COMMUNITY_VIEW : ProjectLinks.LINK_CHARITY_VIEW,
          this.entity.community?.entity_id ?? '',
        ]
      : [];
  }
}
